export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_8a194d3a-5ace-44fb-a4d7-047b65ce8075/artifacts/wog0bs76_ruiz%20services.png";

export const CONTACT = {
  phone: "640918551",
  phoneIntl: "+34640918551",
  phoneDisplay: "640 918 551",
  whatsappUrl: "https://wa.me/34640918551",
  email: "ruizcarehomes@gmail.com",
  address: "Munguía, Bizkaia",
  hoursShort: "L–D · 6:00 – 23:00",
};

export const IMAGES = {
  hero:
    "https://images.pexels.com/photos/32097869/pexels-photo-32097869.jpeg",
  gardening:
    "https://images.pexels.com/photos/32427440/pexels-photo-32427440.jpeg",
  maintenance:
    "https://images.pexels.com/photos/4792495/pexels-photo-4792495.jpeg",
  garbage:
    "https://images.unsplash.com/photo-1611284446314-60a58ac0deb9",
  about:
    "https://images.unsplash.com/photo-1596546235731-27cca6b8762d",
};
